@let fieldData = field();
@let formControl = control();

@if (formControl) {
  <div class="mb-6 relative">
    <button
      tuiButton
      type="button"
      appearance="outline"
      [disabled]="!canExecute() || formControl.disabled"
      [ngStyle]="{
        backgroundColor: fieldData.color ? fieldData.color : '',
      }"
      class="w-full h-12 rounded-lg text-start px-4 x-font-body-3"
    >
      {{ fieldData.title }}
    </button>
  </div>
}
